/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Edit_Event_Group_Error_Detection_HeadingInputs */



/**
* | output |
* | --- |
* | "Error Detection" |
*
* @param {Edit_Event_Group_Error_Detection_HeadingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const edit_event_group_error_detection_heading = /** @type {((inputs?: Edit_Event_Group_Error_Detection_HeadingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Edit_Event_Group_Error_Detection_HeadingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Détection d'erreurs")
	if (locale === "de") return /** @type {LocalizedString} */ ("Fehlererkennung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rilevamento degli errori")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обнаружение ошибок")
	if (locale === "es") return /** @type {LocalizedString} */ ("Detección de errores")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("错误检测")
	if (locale === "ja") return /** @type {LocalizedString} */ ("エラー検出")
	if (locale === "hi") return /** @type {LocalizedString} */ ("त्रुटि का पता लगाना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Detecção de erro")
	return /** @type {LocalizedString} */ ("Error Detection")
});